
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.443 5.365h-.36V3.627l-.003-.032a.289.289 0 00-.07-.19L9.118.1 9.116.099a.286.286 0 00-.078-.061.308.308 0 00-.058-.024L8.964.008A.296.296 0 008.897 0H1.789a.589.589 0 00-.588.588v4.777H.84A.84.84 0 000 6.206v4.372c0 .464.376.84.84.84h.36v2.994c0 .324.265.588.59.588h9.705a.589.589 0 00.588-.588v-2.993h.36c.465 0 .841-.377.841-.84V6.205a.84.84 0 00-.84-.84zM1.79.588h6.814v3.01c0 .162.131.294.294.294h2.598v1.473H1.789V.588zm4.428 7.98c-.73-.254-1.205-.658-1.205-1.297 0-.75.625-1.323 1.661-1.323.496 0 .86.104 1.121.222l-.221.802a2.083 2.083 0 00-.92-.21c-.43 0-.638.196-.638.424 0 .28.248.404.815.62.775.286 1.14.69 1.14 1.31 0 .735-.567 1.361-1.772 1.361-.502 0-.997-.13-1.245-.267l.202-.821a2.53 2.53 0 001.102.274c.456 0 .697-.19.697-.476 0-.274-.209-.43-.737-.62zM1.043 8.28c0-1.499 1.069-2.333 2.398-2.333.515 0 .906.104 1.082.196l-.203.788a2.152 2.152 0 00-.834-.162c-.788 0-1.4.475-1.4 1.452 0 .88.52 1.434 1.407 1.434.3 0 .632-.065.827-.143l.15.775c-.182.091-.592.19-1.127.19-1.518 0-2.3-.946-2.3-2.197zm10.452 5.971H1.789V11.42h9.706v2.833zm-.657-3.84h-1.16L8.27 6.02H9.36l.534 1.857c.15.521.287 1.023.391 1.57h.02c.11-.527.247-1.049.397-1.55l.56-1.877h1.057l-1.48 4.392z","fill":"#E2E8F0"}})])
          )
        }
      }
    